var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buyside_fail_container mx-auto text-center"},[_c('div',{staticClass:"buyside_fail"},[_c('BuysideLogo'),_c('p',{staticClass:"text-center error_text"},[_vm._v("An error occured. Please try again.")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }